module.exports = __webpack_public_path__ + "static/media/munster.db9a9622.png";